
define('text!modules/file_upload/upload_item_template.html',[],function () { return '<div class="file-items" data-id="<%- id %>">\r\n  <div class="file-upload-progress"><span style="width: <%- progress %>;"></span></div>\r\n</div>\r\n';});

